import { render, staticRenderFns } from "./appLogs.vue?vue&type=template&id=3b9243cd&scoped=true"
import script from "./appLogs.vue?vue&type=script&lang=js"
export * from "./appLogs.vue?vue&type=script&lang=js"
import style0 from "./appLogs.vue?vue&type=style&index=0&id=3b9243cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9243cd",
  null
  
)

export default component.exports